export default __webpack_public_path__ + "static/media/bad-2.669fa3ff.png";